module.exports = __webpack_public_path__ + "img/甘草.cb90a5ca.jpg";